const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20scene%20of%20a%20person%20holding%20a%20phone%20displaying%20colorful%20manga%20content%20in%20vertical%20scroll%20format%2C%20warm%20indoor%20lighting%2C%20comfortable%20couch%20setting%2C%20cream%20and%20coral%20tones%2C%20lifestyle%20photography%20style%2C%20clean%20composition&width=600&height=340&seq=media-01&orientation=landscape',
    title: '竖屏阅读新体验',
    desc: '告别传统左右翻页，感受下拉式竖屏阅读的流畅魅力',
    duration: '功能演示',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20flat%20lay%20of%20a%20tablet%20and%20phone%20displaying%20Japanese%20manga%20and%20Korean%20webtoon%20content%20side%20by%20side%2C%20warm%20natural%20light%2C%20minimal%20desk%20setup%2C%20cream%20and%20amber%20tones%2C%20editorial%20style&width=600&height=340&seq=media-02&orientation=landscape',
    title: '跨设备畅读',
    desc: '手机、平板、电脑无缝切换，阅读进度全平台自动同步',
    duration: '使用教程',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20top-down%20view%20of%20a%20phone%20screen%20showing%20a%20comic%20reading%20app%20interface%20with%20colorful%20manga%20thumbnails%20in%20a%20grid%20layout%2C%20soft%20indoor%20lighting%2C%20cream%20background%2C%20clean%20minimal%20aesthetic&width=600&height=340&seq=media-03&orientation=landscape',
    title: '海量内容发现',
    desc: '智能推荐+专题合集，帮你快速找到下一部心头好漫画',
    duration: '功能展示',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-3">
            媒体展示
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            通过图文演示了解酷漫屋的核心功能与使用方式
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, i) => {
            const isAccent = i === 1;
            return (
              <a
                key={item.title}
                href="#media"
                className={`group rounded-lg overflow-hidden cursor-pointer transition-colors ${
                  isAccent
                    ? 'bg-accent-50 hover:bg-accent-100/80'
                    : 'bg-background-100 hover:bg-background-200/60'
                }`}
              >
                <div className="relative w-full aspect-[16/9] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-background-950/30 flex items-center justify-center">
                    <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500">
                      <i className="ri-play-circle-fill text-2xl md:text-3xl"></i>
                    </div>
                  </div>
                  <span className="absolute bottom-3 right-3 px-2 py-0.5 bg-background-950/70 text-background-50 text-xs rounded">
                    {item.duration}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="font-heading text-base text-foreground-950 mb-1.5 whitespace-nowrap">{item.title}</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}